"use client";

import SocialShareBtns, {
  ShareIconTypes,
} from "@/app/components/pages-components/common/social-share-btns/SocialShareBtns";
import { useTranslation } from "@/hooks/localization/useTranslations";

const SocailShareBox = () => {
  const t = useTranslation();
  return (
    <div className="box-with-title">
      <SocialShareBtns startLabel={t.share_post} type={ShareIconTypes.blog} />
    </div>
  );
};

export default SocailShareBox;
